import { useState, useEffect } from 'react';
import { useAppStatus } from 'src/context/AppStatusContext';
import { useUtcCountdown, computeUtcDiffMinutes } from 'src/hooks/useUtcCountdown';
import { BannerStrip } from 'src/components/common/banner/BannerStrip';

const MaintenanceBanner = () => {
    const { maintenanceMode, refetch } = useAppStatus();
    const [dismissed, setDismissed] = useState(false);
    const startsInMinutes = useUtcCountdown(maintenanceMode?.scheduledStartTimeUtc);

    // Reset dismiss when the maintenance schedule changes
    useEffect(() => {
        setDismissed(false);
    }, [maintenanceMode?.scheduledStartTimeUtc]);

    // Trigger refetch when countdown reaches 0 so the guard switches to MaintenancePage
    useEffect(() => {
        if (startsInMinutes === 0) {
            refetch();
        }
    }, [startsInMinutes, refetch]);

    if (dismissed || !maintenanceMode?.isMaintenanceScheduled) return null;

    const estimatedDowntime = computeUtcDiffMinutes(maintenanceMode.scheduledStartTimeUtc, maintenanceMode.estimatedEndTimeUtc);
    const downtimeSuffix =
        estimatedDowntime != null ? ` Expected downtime: approximately ${estimatedDowntime} minute${estimatedDowntime !== 1 ? 's' : ''}.` : '';

    const liveMinutes = startsInMinutes ?? 0;
    const message =
        liveMinutes > 0
            ? `Scheduled maintenance starting in ${liveMinutes} minute${liveMinutes !== 1 ? 's' : ''}.${downtimeSuffix} Please save your work.`
            : `Maintenance is about to begin. Please save your work now.`;

    return (
        <BannerStrip
            variant="warning"
            message={message}
            onDismiss={() => setDismissed(true)}
            dismissAriaLabel="Dismiss maintenance notice"
        />
    );
};

export default MaintenanceBanner;
